module.exports = __webpack_public_path__ + "static/media/zmt_bg.92fe880d.png";